export const ptBRHomeTranslation = {
  home: {
    welcome_back: 'Bem-vindo(a) de volta, {{name}}',
    subtitle: 'Veja um resumo atualizado dos últimos índices da sua empresa.',

    viewing_now: 'Visualizando agora',
    company: 'Empresa',
    month: 'Mês',

    notifications: {
      title: 'Notificações',
      empty: 'Sem notificações',
    },

    charts: {
      payroll_cost: {
        title: 'Custo da folha nominal/mensal',
      },
      salary_mass_by_level: {
        title: 'Massa salarial por nível',
      },
      headcount_by_level: {
        title: 'Headcount por nível',
      },
      personnel_cost_result: {
        title: 'Custo de pessoal/resultado',
        net_revenue: 'Receita Líquida',
        ebitda: 'Ebitda',
        personnel_cost: 'Custo Pessoal',
        personnel_cost_by_ebitda: 'Custo Pessoal / Ebitda',
        personnel_cost_by_net_revenue: 'Custo Pessoal / Receita Líquida',
      },
      current_payroll: {
        title: 'Folha atual/mensal',
        nominal: 'Nominal',
        with_charges: 'Com encargos',
        info: 'Este é o custo total anual projetado da folha de pagamento.\n\nNominal: A soma de todos os salários brutos (base), antes de custos adicionais.\n\nCom encargos: O custo total efetivo para a empresa, incluindo salários, encargos sociais (INSS, FGTS), benefícios e provisões (13º, férias).',
      },
      payroll_budget: {
        title: 'Orçamento de folha/anual',
        nominal: 'Nominal',
        with_charges: 'Com encargos',
        info: 'Este é o custo total da folha de pagamento referente ao mês atual.\n\nNominal: A soma de todos os salários brutos (base) pagos neste mês.\n\nCom encargos: O custo total efetivo do mês para a empresa, incluindo salários, encargos sociais (INSS, FGTS), benefícios e as provisões mensais (13º, férias).',
      },
      average_salary: {
        title: 'Média salarial por nível',
        salary_fixed: 'Salário + Adicionais fixos',
        icp: 'ICP',
        ilp: 'ILP',
        benefits: 'Benefícios',
      },
      position_rate: {
        title: 'Posicionamento na faixa',
        below_range: 'Abaixo da faixa',
        between_min_100: 'Entre o mínimo e 100%',
        between_100_max: 'Entre 100% e o máximo',
        above_max: 'Acima do máximo',
      },
      headcount: {
        title: 'Headcount',
      },
    },
  },
};
